import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownSection,
  DropdownTrigger,
} from '@heroui/react';
import { Bell } from 'lucide-react';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetNewClientRequestsFromFirestore } from '../../../queries';
import { ClientRequestFirestoreResponse } from '../../../types';

const MAX_VISIBLE = 8;

const formatDate = (request: ClientRequestFirestoreResponse): string => {
  const ts = request.createdAt;
  if (ts?.toDate) return ts.toDate().toLocaleString('pl-PL');
  return request.timestamp || '';
};

export const NotificationsBell: FC = () => {
  const navigate = useNavigate();
  const { data: newRequests = [] } = useGetNewClientRequestsFromFirestore();
  const count = newRequests.length;

  const goToRequests = () => navigate('/client-requests');

  return (
    <Dropdown placement="bottom-end">
      <DropdownTrigger>
        <div
          aria-label="Powiadomienia o nowych zgłoszeniach"
          title="Nowe zgłoszenia"
          className="relative flex items-center cursor-pointer hover:opacity-70 transition-opacity text-gray-600"
        >
          <Bell size={20} />
          {count > 0 && (
            <span className="absolute -top-2 -right-2 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-semibold leading-none text-white">
              {count > 9 ? '9+' : count}
            </span>
          )}
        </div>
      </DropdownTrigger>
      {count === 0 ? (
        <DropdownMenu aria-label="Nowe zgłoszenia" variant="flat" className="w-[320px]">
          <DropdownItem key="empty" isReadOnly className="text-gray-400 opacity-100">
            Brak nowych zgłoszeń
          </DropdownItem>
        </DropdownMenu>
      ) : (
        <DropdownMenu aria-label="Nowe zgłoszenia" variant="flat" className="w-[340px]">
          <DropdownSection title={`Nowe zgłoszenia (${count})`} showDivider>
            {newRequests.slice(0, MAX_VISIBLE).map((request) => (
              <DropdownItem
                key={request.id}
                onPress={goToRequests}
                description={(
                  <span className="text-xs text-gray-400">
                    {request.hotelName || request.userName || '—'}
                    {' · '}
                    {formatDate(request)}
                  </span>
                )}
              >
                <span className="font-medium text-gray-800">
                  {request.subject || 'Nowe zgłoszenie'}
                </span>
              </DropdownItem>
            ))}
          </DropdownSection>
          <DropdownItem key="see-all" className="text-primary" onPress={goToRequests}>
            Zobacz wszystkie zgłoszenia
          </DropdownItem>
        </DropdownMenu>
      )}
    </Dropdown>
  );
};
